import { render } from "./TurnoCheckIn.vue?vue&type=template&id=218db387&scoped=true&ts=true"
import script from "./TurnoCheckIn.vue?vue&type=script&lang=ts"
export * from "./TurnoCheckIn.vue?vue&type=script&lang=ts"

import "./TurnoCheckIn.vue?vue&type=style&index=0&id=218db387&scoped=true&lang=css"

import exportComponent from "/home/rdimicheleb/Repos/AMII/apps/app-paciente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-218db387"]])

export default __exports__